"use strict";

var _slicedToArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/vercel/path1/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/vercel/path1/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path1/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = exports.LintConfig = exports.DOMAINS = exports.DEFAULT_REGION = exports.IGNORE_FILE = void 0;

var fs = require("fs");

var path = require("path");

var path_1 = require("path");

var colorette_1 = require("colorette");

var js_yaml_1 = require("../js-yaml");

var utils_1 = require("../utils");

var oas_types_1 = require("../oas-types");

var recommended_1 = require("./recommended");

exports.IGNORE_FILE = '.redocly.lint-ignore.yaml';
var IGNORE_BANNER = "# This file instructs Redocly's linter to ignore the rules contained for specific parts of your API.\n" + "# See https://redoc.ly/docs/cli/ for more information.\n";
exports.DEFAULT_REGION = 'us';
var REDOCLY_DOMAIN = process.env.REDOCLY_DOMAIN;
exports.DOMAINS = {
  us: 'redoc.ly',
  eu: 'eu.redocly.com'
}; // FIXME: temporary fix for our lab environments

if (REDOCLY_DOMAIN === null || REDOCLY_DOMAIN === void 0 ? void 0 : REDOCLY_DOMAIN.endsWith('.redocly.host')) {
  exports.DOMAINS[REDOCLY_DOMAIN.split('.')[0]] = REDOCLY_DOMAIN;
}

if (REDOCLY_DOMAIN === 'redoc.online') {
  exports.DOMAINS[REDOCLY_DOMAIN] = REDOCLY_DOMAIN;
}

var LintConfig = /*#__PURE__*/function () {
  function LintConfig(rawConfig, configFile) {
    var _this$rules, _this$preprocessors, _this$decorators;

    _classCallCheck(this, LintConfig);

    this.rawConfig = rawConfig;
    this.configFile = configFile;
    this.ignore = {};
    this._usedRules = new Set();
    this._usedVersions = new Set();
    this.recommendedFallback = false;
    this.plugins = rawConfig.plugins ? resolvePlugins(rawConfig.plugins, configFile) : [];
    this.doNotResolveExamples = !!rawConfig.doNotResolveExamples;

    if (!rawConfig.extends) {
      this.recommendedFallback = true;
    }

    var extendConfigs = rawConfig.extends ? resolvePresets(rawConfig.extends, this.plugins) : [recommended_1.default];

    if (rawConfig.rules || rawConfig.preprocessors || rawConfig.decorators) {
      extendConfigs.push({
        rules: rawConfig.rules,
        preprocessors: rawConfig.preprocessors,
        decorators: rawConfig.decorators
      });
    }

    var merged = mergeExtends(extendConfigs);
    this.rules = (_this$rules = {}, _defineProperty(_this$rules, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, merged.rules), merged.oas2Rules)), _defineProperty(_this$rules, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, merged.rules), merged.oas3_0Rules)), _defineProperty(_this$rules, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, merged.rules), merged.oas3_1Rules)), _this$rules);
    this.preprocessors = (_this$preprocessors = {}, _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, merged.preprocessors), merged.oas2Preprocessors)), _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, merged.preprocessors), merged.oas3_0Preprocessors)), _defineProperty(_this$preprocessors, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, merged.preprocessors), merged.oas3_1Preprocessors)), _this$preprocessors);
    this.decorators = (_this$decorators = {}, _defineProperty(_this$decorators, oas_types_1.OasVersion.Version2, Object.assign(Object.assign({}, merged.decorators), merged.oas2Decorators)), _defineProperty(_this$decorators, oas_types_1.OasVersion.Version3_0, Object.assign(Object.assign({}, merged.decorators), merged.oas3_0Decorators)), _defineProperty(_this$decorators, oas_types_1.OasVersion.Version3_1, Object.assign(Object.assign({}, merged.decorators), merged.oas3_1Decorators)), _this$decorators);
    var dir = this.configFile ? path.dirname(this.configFile) : typeof process !== 'undefined' && process.cwd() || '';
    var ignoreFile = path.join(dir, exports.IGNORE_FILE);
    /* no crash when using it on the client */

    if (fs.hasOwnProperty('existsSync') && fs.existsSync(ignoreFile)) {
      // TODO: parse errors
      this.ignore = js_yaml_1.parseYaml(fs.readFileSync(ignoreFile, 'utf-8')) || {}; // resolve ignore paths

      for (var _i = 0, _Object$keys = Object.keys(this.ignore); _i < _Object$keys.length; _i++) {
        var fileName = _Object$keys[_i];
        this.ignore[path.resolve(path_1.dirname(ignoreFile), fileName)] = this.ignore[fileName];

        for (var _i2 = 0, _Object$keys2 = Object.keys(this.ignore[fileName]); _i2 < _Object$keys2.length; _i2++) {
          var ruleId = _Object$keys2[_i2];
          this.ignore[fileName][ruleId] = new Set(this.ignore[fileName][ruleId]);
        }

        delete this.ignore[fileName];
      }
    }
  }

  _createClass(LintConfig, [{
    key: "saveIgnore",
    value: function saveIgnore() {
      var dir = this.configFile ? path.dirname(this.configFile) : process.cwd();
      var ignoreFile = path.join(dir, exports.IGNORE_FILE);
      var mapped = {};

      for (var _i3 = 0, _Object$keys3 = Object.keys(this.ignore); _i3 < _Object$keys3.length; _i3++) {
        var absFileName = _Object$keys3[_i3];
        var ignoredRules = mapped[utils_1.slash(path.relative(dir, absFileName))] = this.ignore[absFileName];

        for (var _i4 = 0, _Object$keys4 = Object.keys(ignoredRules); _i4 < _Object$keys4.length; _i4++) {
          var ruleId = _Object$keys4[_i4];
          ignoredRules[ruleId] = Array.from(ignoredRules[ruleId]);
        }
      }

      fs.writeFileSync(ignoreFile, IGNORE_BANNER + js_yaml_1.stringifyYaml(mapped));
    }
  }, {
    key: "addIgnore",
    value: function addIgnore(problem) {
      var ignore = this.ignore;
      var loc = problem.location[0];
      if (loc.pointer === undefined) return;
      var fileIgnore = ignore[loc.source.absoluteRef] = ignore[loc.source.absoluteRef] || {};
      var ruleIgnore = fileIgnore[problem.ruleId] = fileIgnore[problem.ruleId] || new Set();
      ruleIgnore.add(loc.pointer);
    }
  }, {
    key: "addProblemToIgnore",
    value: function addProblemToIgnore(problem) {
      var loc = problem.location[0];
      if (loc.pointer === undefined) return problem;
      var fileIgnore = this.ignore[loc.source.absoluteRef] || {};
      var ruleIgnore = fileIgnore[problem.ruleId];
      var ignored = ruleIgnore && ruleIgnore.has(loc.pointer);
      return ignored ? Object.assign(Object.assign({}, problem), {
        ignored: ignored
      }) : problem;
    }
  }, {
    key: "extendTypes",
    value: function extendTypes(types, version) {
      var extendedTypes = types;

      var _iterator = _createForOfIteratorHelper(this.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;

          if (plugin.typeExtension !== undefined) {
            switch (version) {
              case oas_types_1.OasVersion.Version3_0:
              case oas_types_1.OasVersion.Version3_1:
                if (!plugin.typeExtension.oas3) continue;
                extendedTypes = plugin.typeExtension.oas3(extendedTypes, version);

              case oas_types_1.OasVersion.Version2:
                if (!plugin.typeExtension.oas2) continue;
                extendedTypes = plugin.typeExtension.oas2(extendedTypes, version);

              default:
                throw new Error('Not implemented');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return extendedTypes;
    }
  }, {
    key: "getRuleSettings",
    value: function getRuleSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.rules[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getPreprocessorSettings",
    value: function getPreprocessorSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.preprocessors[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings === 'on' ? 'error' : settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getDecoratorSettings",
    value: function getDecoratorSettings(ruleId, oasVersion) {
      this._usedRules.add(ruleId);

      this._usedVersions.add(oasVersion);

      var settings = this.decorators[oasVersion][ruleId] || 'off';

      if (typeof settings === 'string') {
        return {
          severity: settings === 'on' ? 'error' : settings
        };
      } else {
        return Object.assign({
          severity: 'error'
        }, settings);
      }
    }
  }, {
    key: "getUnusedRules",
    value: function getUnusedRules() {
      var _this = this;

      var rules = [];
      var decorators = [];
      var preprocessors = [];

      for (var _i5 = 0, _Array$from = Array.from(this._usedVersions); _i5 < _Array$from.length; _i5++) {
        var usedVersion = _Array$from[_i5];
        rules.push.apply(rules, _toConsumableArray(Object.keys(this.rules[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
        decorators.push.apply(decorators, _toConsumableArray(Object.keys(this.decorators[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
        preprocessors.push.apply(preprocessors, _toConsumableArray(Object.keys(this.preprocessors[usedVersion]).filter(function (name) {
          return !_this._usedRules.has(name);
        })));
      }

      return {
        rules: rules,
        preprocessors: preprocessors,
        decorators: decorators
      };
    }
  }, {
    key: "getRulesForOasVersion",
    value: function getRulesForOasVersion(version) {
      switch (version) {
        case oas_types_1.OasMajorVersion.Version3:
          var oas3Rules = []; // default ruleset

          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.preprocessors) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.preprocessors.oas3);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.rules) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.rules.oas3);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.decorators) === null || _a === void 0 ? void 0 : _a.oas3) && oas3Rules.push(p.decorators.oas3);
          });
          return oas3Rules;

        case oas_types_1.OasMajorVersion.Version2:
          var oas2Rules = []; // default ruleset

          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.preprocessors) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.preprocessors.oas2);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.rules) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.rules.oas2);
          });
          this.plugins.forEach(function (p) {
            var _a;

            return ((_a = p.decorators) === null || _a === void 0 ? void 0 : _a.oas2) && oas2Rules.push(p.decorators.oas2);
          });
          return oas2Rules;
      }
    }
  }, {
    key: "skipRules",
    value: function skipRules(rules) {
      var _iterator2 = _createForOfIteratorHelper(rules || []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ruleId = _step2.value;

          for (var _i6 = 0, _Object$values = Object.values(oas_types_1.OasVersion); _i6 < _Object$values.length; _i6++) {
            var version = _Object$values[_i6];

            if (this.rules[version][ruleId]) {
              this.rules[version][ruleId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "skipPreprocessors",
    value: function skipPreprocessors(preprocessors) {
      var _iterator3 = _createForOfIteratorHelper(preprocessors || []),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var preprocessorId = _step3.value;

          for (var _i7 = 0, _Object$values2 = Object.values(oas_types_1.OasVersion); _i7 < _Object$values2.length; _i7++) {
            var version = _Object$values2[_i7];

            if (this.preprocessors[version][preprocessorId]) {
              this.preprocessors[version][preprocessorId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "skipDecorators",
    value: function skipDecorators(decorators) {
      var _iterator4 = _createForOfIteratorHelper(decorators || []),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var decoratorId = _step4.value;

          for (var _i8 = 0, _Object$values3 = Object.values(oas_types_1.OasVersion); _i8 < _Object$values3.length; _i8++) {
            var version = _Object$values3[_i8];

            if (this.decorators[version][decoratorId]) {
              this.decorators[version][decoratorId] = 'off';
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }]);

  return LintConfig;
}();

exports.LintConfig = LintConfig;

var Config = /*#__PURE__*/_createClass(function Config(rawConfig, configFile) {
  _classCallCheck(this, Config);

  var _a, _b, _c;

  this.rawConfig = rawConfig;
  this.configFile = configFile;
  this.apiDefinitions = rawConfig.apiDefinitions || {};
  this.lint = new LintConfig(rawConfig.lint || {}, configFile);
  this.referenceDocs = rawConfig.referenceDocs || {};
  this.resolve = {
    http: {
      headers: (_c = (_b = (_a = rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.resolve) === null || _a === void 0 ? void 0 : _a.http) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : [],
      customFetch: undefined
    }
  };
  this.region = rawConfig.region;
});

exports.Config = Config;

function resolvePresets(presets, plugins) {
  return presets.map(function (presetName) {
    var _a;

    var _parsePresetName = parsePresetName(presetName),
        pluginId = _parsePresetName.pluginId,
        configName = _parsePresetName.configName;

    var plugin = plugins.find(function (p) {
      return p.id === pluginId;
    });

    if (!plugin) {
      throw new Error("Invalid config ".concat(colorette_1.red(presetName), ": plugin ").concat(pluginId, " is not included."));
    }

    var preset = (_a = plugin.configs) === null || _a === void 0 ? void 0 : _a[configName];

    if (!preset) {
      throw new Error(pluginId ? "Invalid config ".concat(colorette_1.red(presetName), ": plugin ").concat(pluginId, " doesn't export config with name ").concat(configName, ".") : "Invalid config ".concat(colorette_1.red(presetName), ": there is no such built-in config."));
    }

    return preset;
  });
}

function parsePresetName(presetName) {
  if (presetName.indexOf('/') > -1) {
    var _presetName$split = presetName.split('/'),
        _presetName$split2 = _slicedToArray(_presetName$split, 2),
        pluginId = _presetName$split2[0],
        configName = _presetName$split2[1];

    return {
      pluginId: pluginId,
      configName: configName
    };
  } else {
    return {
      pluginId: '',
      configName: presetName
    };
  }
}

function resolvePlugins(plugins) {
  var configPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!plugins) return []; // @ts-ignore

  var requireFunc = typeof __webpack_require__ === 'function' ? __non_webpack_require__ : require;
  var seenPluginIds = new Map();
  return plugins.map(function (p) {
    // TODO: resolve npm packages similar to eslint
    var pluginModule = typeof p === 'string' ? requireFunc(path.resolve(path.dirname(configPath), p)) : p;
    var id = pluginModule.id;

    if (typeof id !== 'string') {
      throw new Error(colorette_1.red("Plugin must define `id` property in ".concat(colorette_1.blue(p.toString()), ".")));
    }

    if (seenPluginIds.has(id)) {
      var pluginPath = seenPluginIds.get(id);
      throw new Error(colorette_1.red("Plugin \"id\" must be unique. Plugin ".concat(colorette_1.blue(p.toString()), " uses id \"").concat(colorette_1.blue(id), "\" already seen in ").concat(colorette_1.blue(pluginPath))));
    }

    seenPluginIds.set(id, p.toString());
    var plugin = Object.assign(Object.assign({
      id: id
    }, pluginModule.configs ? {
      configs: pluginModule.configs
    } : {}), pluginModule.typeExtension ? {
      typeExtension: pluginModule.typeExtension
    } : {});

    if (pluginModule.rules) {
      if (!pluginModule.rules.oas3 && !pluginModule.rules.oas2) {
        throw new Error("Plugin rules must have `oas3` or `oas2` rules \"".concat(p, "."));
      }

      plugin.rules = {};

      if (pluginModule.rules.oas3) {
        plugin.rules.oas3 = prefixRules(pluginModule.rules.oas3, id);
      }

      if (pluginModule.rules.oas2) {
        plugin.rules.oas2 = prefixRules(pluginModule.rules.oas2, id);
      }
    }

    if (pluginModule.preprocessors) {
      if (!pluginModule.preprocessors.oas3 && !pluginModule.preprocessors.oas2) {
        throw new Error("Plugin `preprocessors` must have `oas3` or `oas2` preprocessors \"".concat(p, "."));
      }

      plugin.preprocessors = {};

      if (pluginModule.preprocessors.oas3) {
        plugin.preprocessors.oas3 = prefixRules(pluginModule.preprocessors.oas3, id);
      }

      if (pluginModule.preprocessors.oas2) {
        plugin.preprocessors.oas2 = prefixRules(pluginModule.preprocessors.oas2, id);
      }
    }

    if (pluginModule.decorators) {
      if (!pluginModule.decorators.oas3 && !pluginModule.decorators.oas2) {
        throw new Error("Plugin `decorators` must have `oas3` or `oas2` decorators \"".concat(p, "."));
      }

      plugin.decorators = {};

      if (pluginModule.decorators.oas3) {
        plugin.decorators.oas3 = prefixRules(pluginModule.decorators.oas3, id);
      }

      if (pluginModule.decorators.oas2) {
        plugin.decorators.oas2 = prefixRules(pluginModule.decorators.oas2, id);
      }
    }

    return plugin;
  }).filter(utils_1.notUndefined);
}

function prefixRules(rules, prefix) {
  if (!prefix) return rules;
  var res = {};

  for (var _i9 = 0, _Object$keys5 = Object.keys(rules); _i9 < _Object$keys5.length; _i9++) {
    var name = _Object$keys5[_i9];
    res["".concat(prefix, "/").concat(name)] = rules[name];
  }

  return res;
}

function mergeExtends(rulesConfList) {
  var result = {
    rules: {},
    oas2Rules: {},
    oas3_0Rules: {},
    oas3_1Rules: {},
    preprocessors: {},
    oas2Preprocessors: {},
    oas3_0Preprocessors: {},
    oas3_1Preprocessors: {},
    decorators: {},
    oas2Decorators: {},
    oas3_0Decorators: {},
    oas3_1Decorators: {}
  };

  var _iterator5 = _createForOfIteratorHelper(rulesConfList),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var rulesConf = _step5.value;

      if (rulesConf.extends) {
        throw new Error("`extends` is not supported in shared configs yet: ".concat(JSON.stringify(rulesConf, null, 2), "."));
      }

      Object.assign(result.rules, rulesConf.rules);
      Object.assign(result.oas2Rules, rulesConf.oas2Rules);
      assignExisting(result.oas2Rules, rulesConf.rules || {});
      Object.assign(result.oas3_0Rules, rulesConf.oas3_0Rules);
      assignExisting(result.oas3_0Rules, rulesConf.rules || {});
      Object.assign(result.oas3_1Rules, rulesConf.oas3_1Rules);
      assignExisting(result.oas3_1Rules, rulesConf.rules || {});
      Object.assign(result.preprocessors, rulesConf.preprocessors);
      Object.assign(result.oas2Preprocessors, rulesConf.oas2Preprocessors);
      assignExisting(result.oas2Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.oas3_0Preprocessors, rulesConf.oas3_0Preprocessors);
      assignExisting(result.oas3_0Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.oas3_1Preprocessors, rulesConf.oas3_1Preprocessors);
      assignExisting(result.oas3_1Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.decorators, rulesConf.decorators);
      Object.assign(result.oas2Decorators, rulesConf.oas2Decorators);
      assignExisting(result.oas2Decorators, rulesConf.decorators || {});
      Object.assign(result.oas3_0Decorators, rulesConf.oas3_0Decorators);
      assignExisting(result.oas3_0Decorators, rulesConf.decorators || {});
      Object.assign(result.oas3_1Decorators, rulesConf.oas3_1Decorators);
      assignExisting(result.oas3_1Decorators, rulesConf.decorators || {});
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return result;
}

function assignExisting(target, obj) {
  for (var _i10 = 0, _Object$keys6 = Object.keys(obj); _i10 < _Object$keys6.length; _i10++) {
    var k = _Object$keys6[_i10];

    if (target.hasOwnProperty(k)) {
      target[k] = obj[k];
    }
  }
}